var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackVizzhyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 93,
    rx: 14,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5047 62.7439C43.5047 65.6133 45.8199 67.9399 48.6752 67.9399C51.5306 67.9399 53.8457 65.6133 53.8457 62.7439C53.8457 59.8745 51.5306 57.548 48.6752 57.548C45.8199 57.548 43.5047 59.8745 43.5047 62.7439ZM29.6307 47.721C29.6307 51.3346 32.5471 54.2655 36.143 54.2655C41.1777 54.2655 41.4545 48.7076 48.5733 48.7076C54.0971 48.7076 55.4458 52.5756 58.3929 52.5756C61.0613 52.5756 63.2236 50.4009 63.2236 47.721C63.2236 45.0411 61.0613 42.8664 58.3929 42.8664C55.3524 42.8664 54.0445 46.6491 48.5733 46.6491C41.5548 46.6491 41.1709 41.1749 36.143 41.1749C32.5471 41.1749 29.6307 44.1057 29.6307 47.721ZM60.8133 31.3462C60.8133 34.2156 63.1285 36.5422 65.9838 36.5422C68.8392 36.5422 71.1544 34.2156 71.1544 31.3462C71.1544 28.4768 68.8392 26.1502 65.9838 26.1502C63.1285 26.1502 60.8133 28.4751 60.8133 31.3462ZM36.3503 30.2742C30.8791 30.2742 29.5712 26.4916 26.5307 26.4916C23.8623 26.4916 21.7 28.6646 21.7 31.3462C21.7 34.0278 23.8623 36.2008 26.5307 36.2008C29.4778 36.2008 30.8265 32.3328 36.3503 32.3328C43.4674 32.3328 43.7442 37.8924 48.7805 37.8924C52.3765 37.8924 55.2929 34.9615 55.2929 31.3462C55.2929 27.7309 52.3765 24.8 48.7805 24.8C43.7527 24.8 43.3688 30.2742 36.3503 30.2742Z",
    fill: "url(#paint0_linear_1_5401)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_5401",
    x1: -3.65142,
    y1: 46.2512,
    x2: 114.33,
    y2: 46.2512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482292,
    stopColor: "white",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackVizzhyIcon);
export default __webpack_public_path__ + "static/media/blackVizzhyIcon.b309cac2681ced34e4177b892fce1fb2.svg";
export { ForwardRef as ReactComponent };